<template>
    <v-container>
        <v-row class="contentRow">
            <v-col cols="12">
                <h1 class="mb-2">Team Overview</h1>
                <p class="mb-10 text-center">This is the <b>{{$store.getters["user/getUser"].clientName}}</b> team! <br />Invite your co-workers by clicking "Add User".</p>
            </v-col>
            <v-spacer/>
            <v-col align="start">
                <v-btn v-if="$accessToOperation('USR','U')" to="/team/settings">
					Company Profile<v-icon right>fas fa-cog</v-icon>
                </v-btn>
            </v-col>
            <v-col align="end">
                <v-btn color="primary" to="/team/add">
                Add user<v-icon right>fas fa-plus</v-icon>
                </v-btn>
            </v-col>

            <v-col cols="12">
                <v-data-table
                    theme--
                    light
					:loading="!users"
                    :headers="headers"
                    :items="users"
					:items-per-page="100"
					:footer-props="{
						'items-per-page-options': [5, 10, 15, 20]
					}"
                    class="light table"
                >
				<!-- Removing the "No data available footer" -->
					<template slot="no-data"> 
						<div></div>
					</template>
					<template v-slot:item.remove="{ item }">
						<v-btn color="red" v-on:click="showDeleteDialog(item)">
							<v-icon color="white" small>fas fa-times</v-icon>
						</v-btn>
					</template>
					<template v-slot:item.edit="{item}">
						<v-btn color="primary" @click="editUser(item)"><v-icon>far fa-eye</v-icon></v-btn>
					</template>
                </v-data-table>
            </v-col>            
			<v-dialog v-model="dialogDelete" max-width="500px">
				<v-card>
					<v-card-title>Are you sure you want to remove this co-worker?</v-card-title>
					<v-card-text>Once it is removed, you must send a new request to create a co-worker</v-card-text>
					<v-card-actions>
						<v-btn color="primary" text @click="dialogDelete = false">Close</v-btn>
						<v-btn color="error" text @click="removeRow">Delete</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
        </v-row>
    </v-container>
    
</template>


<script>
import router from "../router"
import UsersAPI from "../api/connections/users"
import LoadingState from "../consts/LoadingState"
import store from "../store"

export default {
	name: "Users",
  
	data() {
		return {
			headers: [
				{text: "Username", value: "username", sortable: false},
				{text: "First Name", value: "firstname", sortable: false},
				{text: "Last Name", value: "lastname", sortable: false},
				{text: "Show", value: "edit", sortable: false}
			],
			dialogDelete: false,
			itemToDelete: null,
			users: []
		}  
	},
	mounted() {
		this.fetchApi()
	},
	watch: {
		isLoggedIn: function(newval) {
			if (newval == false) {
				router.push("/login")
			}
		}
	},
	methods: {
		editUser: function(user) {
			var username = user.username
			this.$router.push({name: "Edit user", params: {username}})
		},
		removeRow() {
			this.dialogDelete = false
			console.log(this.itemToDelete)
			let index = this.users.indexOf(this.itemToDelete)
			console.log(index)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			UsersAPI.deleteUser(this.itemToDelete)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Co-worker was successfully removed from the list.",
						{ root: true }
					)
					this.connections.splice(index, 1)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		showDeleteDialog(item) {
			this.itemToDelete = item.username
			this.dialogDelete = !this.dialogDelete
		},
		async fetchApi() {
			store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
				
			UsersAPI.getUsers().then((rawdata) => {
				this.users = []
				for (let u of rawdata) {
					this.users.push({
						username: u.username,
						fullname: u.fullname,
						firstname: u.firstname,
						lastname: u.lastName,
						edit: null
					})
				}
				
			}).catch(reason => {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					reason,
					{ root: true }
				)
			})
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_END_LOADING,
				null,
				{ root: true }
			)


		}
	}
}
</script>